import { BaseModel } from "../base.model";

export class RefAlliance extends BaseModel {
  id: number;
  name: string;
  short: string;
}
